import React, { useState, useRef, useEffect } from "react"
import { Link } from "gatsby"

const SwiperSlideRef = props => {
  const randomNumber = (min, max) => {
    return Math.random() * (+max - +min) + +min
  }
  const { river, topOffSet, handleClick, popSnapCode } = props
  const [volume, setVolume] = useState(false)
  const [likes] = useState(() => randomNumber(1, 9))
  const [chats] = useState(() => Math.round(randomNumber(10, 99)))
  // const [views] = useState(() => Math.round(randomNumber(3893, 9999)))
  const videoRef = useRef(null)
  const addMySnapChat = () => {
    popSnapCode(river.site)
  }
  useEffect(() => {
    const onIntersection = e => {
      const vid = e[0]
      let auto = true
      if (vid.isIntersecting) {
        let isGoingToPlay = vid.target.play()
        isGoingToPlay
          .then(_ => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch(error => {
            console.log("videorror", error)
            // Auto-play was prevented
            // Show paused UI.
          })
      } else {
        vid.target.pause()
        auto = false
      }
      vid.target.autoplay = auto
    }
    const config = {
      rootMargin: "50px 0px",
      threshold: 0.8,
    }
    let observer = new IntersectionObserver(onIntersection, config)
    observer.observe(videoRef.current)
    return () => observer.disconnect()
  }, [])
  const toggleVolume = () => {
    setVolume(!volume)
  }
  return (
    <div className="swiper-slide" style={{ top: topOffSet }}>
      <div className="side_navigation">
        <div className="row">
          <div className="user">
            <Link to={`/${river.site.site_url}`} className="item formView">
              <img
                src={`https://static.addfriends.com/images/${river.site.site_url}.jpg`}
                alt={river.site.site_name}
              />
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="item" onClick={handleClick}>
            <i className="icon-empty-heart" />
            <span>{Math.round(10 * likes) / 10}k</span>
          </div>
        </div>
        <div className="row">
          <div className="item buttonMsg" onClick={handleClick}>
            <i className="icon-message" />
            <span>{chats}</span>
          </div>
        </div>
        <div className="row">
          <button
            type="button"
            className="button mVolume"
            onClick={toggleVolume}
          >
            <i className={volume ? "icon-sound-full" : "icon-sound-off"} />
          </button>
        </div>
      </div>
      <div className="user_information">
        <div className="name" onClick={addMySnapChat}>
          <i className="icon-snapchat" />{" "}
          {river.site.free_snapchat === "none"
            ? river.site.site_name
            : river.free_snapchat}
        </div>
        <div className="information">{river.msg}</div>
        <div className="bottom">
          {/* <div className="item">
            <span>{views}</span>k views |
          </div>
          <div className="item">{river.length} | </div> */}
          <div className="item">{river.created_at}</div>
        </div>
      </div>
      <div className="user_container">
        <video
          className="cropeVideo"
          controls
          loop
          muted={!volume ? true : false}
          playsInline
          preload="auto"
          onClick={handleClick}
          ref={videoRef}
        >
          <source
            src={`https://static.addfriends.com/vids/${river.site.site_url}/${river.file_name}.mp4`}
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  )
}

export default SwiperSlideRef
